import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setAddressDetails } from 'Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction';
import { GET_ADDRESS_DETAILS } from 'Store/Organization/AutoCompleteAddressDetails/AddressDetailsType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrganizationApiService from './OrganizationApiService';
import { IPayload } from 'Model/IPayload';


function* getAddressDetailsSaga(payload:any): any {
    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.Organization,
        endpoint : `organizations/address/detail?place_id=${payload?.state}`,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Data...."));

        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setAddressDetails(response, payload?.target));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetAddress() {
    yield takeEvery(GET_ADDRESS_DETAILS, getAddressDetailsSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetAddress()
    ])
}
